import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Base from '../Base';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))


function ShootoutGoalEvent({event, teams, players}) {
  const classes = useStyles();
  const scorer = players[event.player];
  const team = teams[scorer.team].id;
  
  return (
    <Base
      team={team}
      type="Shootout Goal"
    >
      <Typography variant="body2">
        Shootout goal scored by{' '}
        <span className={classes.bold}>{scorer.name}</span>
      </Typography>
    </Base>
  )
}

export default ShootoutGoalEvent;
